import { teachingGrades } from "../constants/TeachingGrades.js";
import { teachingSubjects } from "../constants/TeachingSubjects.js";
import { states } from "../constants/States.js";
import { awardLevels } from "../constants/AwardLevels";
import { eligibilityRequirements } from "../constants/EligibilityRequirements";
import { keywordApplicabilities } from "../constants/KeywordApplicabilities";

function longAnd(v1, v2) {
  var hi = 0x80000000;
  var low = 0x7fffffff;
  var hi1 = ~~(v1 / hi);
  var hi2 = ~~(v2 / hi);
  var low1 = v1 & low;
  var low2 = v2 & low;
  var h = hi1 & hi2;
  var l = low1 & low2;
  return h * hi + l;
}

const list = {
  createTeachingSubjectValueList: function(subjectFlag) {
    var subjectList = [];
    teachingSubjects.forEach(s => {
      s.subjects
        .filter(sub => parseInt(sub.value & subjectFlag) === sub.value)
        .map(sub => sub.value)
        .forEach(val => subjectList.push(val));
    });
    return subjectList;
  },

  createTeachingGradeValueList: function(teachingFlag) {
    return teachingGrades
      .filter(g => (g.value & teachingFlag) === g.value)
      .map(g => g.value);
  },

  createAwardLevelValueList: function(levelFlag) {
    return awardLevels
      .filter(c => (c.value & levelFlag) === c.value)
      .map(c => c.value);
  },

  createStateValueList: function(stateFlag) {
    return states
      .filter(c => longAnd(c.value, stateFlag) === c.value)
      .map(c => c.value);
  },

  createEligibilityValueList: function(eligibilityFlag) {
    return eligibilityRequirements
      .filter(c => (c.value & eligibilityFlag) === c.value)
      .map(c => c.value);
  },

  createTeachingSubjectDescriptionList: function(subjectFlag) {
    var subjects = [];
    teachingSubjects.forEach(subject =>
      subject.subjects.forEach(sub => subjects.push(sub))
    );
    var filteredSubjects = subjects.filter(
      s => (s.value & subjectFlag) === s.value
    );
    if (filteredSubjects.length == subjects.length) {
      return "All Categories";
    } else {
      return filteredSubjects
        .map(s => s.description)
        .sort()
        .join(", ");
    }
  },

  createTeachingGradeDescriptionList: function(teachingFlag) {
    return teachingGrades
      .filter(g => (g.value & teachingFlag) === g.value)
      .map(g => g.description)
      .join(", ");
  },

  createStatesDescriptionList: function(stateFlag) {
    var filteredStates = states.filter(
      c => longAnd(c.value, stateFlag) === c.value
    );
    if (filteredStates.length == states.length) {
      return "All States";
    } else {
      return filteredStates
        .map(c => c.description)
        .sort()
        .join(", ");
    }
  },

  createAwardLevelDescriptionList: function(awardLevelFlag) {
    return awardLevels
      .filter(c => (c.value & awardLevelFlag) === c.value)
      .map(c => c.description)
      .sort()
      .join(", ");
  },

  createEligibilityDescriptionList: function(eligibilityFlag) {
    var eligibilities = eligibilityRequirements.filter(
      c => (c.value & eligibilityFlag) === c.value
    );
    return {
      cant: eligibilities
        .filter(e => e.group == "Can't")
        .map(c => c.description)
        .sort()
        .join(", "),
      must: eligibilities
        .filter(e => e.group == "Must")
        .map(c => c.description)
        .sort()
        .join(", ")
    };
  },

  createKeywordApplicabilityValueList: function(applicabilityFlag) {
    return keywordApplicabilities
      .filter(g => (g.value & applicabilityFlag) === g.value)
      .map(g => g.value);
  }
};

export { list };
